import React, { useMemo, useState } from "react";

interface FoodMenuItem {
    meal: string;
    item: string;
}

const HostelContent: React.FC = () => {
    const [selectedDate, setSelectedDate] = useState(new Date());

    const hostel = {
        id: 1,
        title: "Boys Hostel",
        ward: "Ward 04",
        room: "Room 102",
        incharge: "Mr. Rajesh Kumar",
    };

    const scheduleList = [
        "Wakeup - 6:00 AM",
        "Study Hour - 7:00 AM",
        "Morning Snack - 8:30 AM",
        "School Time - 9:00 AM",
        "Lunch Break - 1:00 PM",
        "Evening Snack - 4:30 PM",
        "Dinner - 8:00 PM",
        "Bed Time - 10:00 PM",
    ];

    const foodMenu: FoodMenuItem[] = useMemo(() => {
        const day = selectedDate.toLocaleDateString("en-US", {
            weekday: "long",
        });

        if (day === "Sunday") {
            return [
                { meal: "Breakfast", item: "Idli & Sambar" },
                { meal: "Lunch", item: "Chicken Biryani" },
                { meal: "Snack", item: "Samosa & Tea" },
                { meal: "Dinner", item: "Chapathi & Paneer Curry" },
            ];
        }

        if (day === "Saturday") {
            return [
                { meal: "Breakfast", item: "Dosa & Chutney" },
                { meal: "Lunch", item: "Veg Fried Rice" },
                { meal: "Snack", item: "Biscuits & Milk" },
                { meal: "Dinner", item: "Veg Curry & Rice" },
            ];
        }

        return [
            { meal: "Breakfast", item: "Upma & Banana" },
            { meal: "Lunch", item: "Rice, Dal & Curry" },
            { meal: "Snack", item: "Tea & Puff" },
            { meal: "Dinner", item: "Chapathi & Dal" },
        ];
    }, [selectedDate]);

    const previousDay = () => {
        const newDate = new Date(selectedDate);
        newDate.setDate(newDate.getDate() - 1);
        setSelectedDate(newDate);
    };

    const nextDay = () => {
        const newDate = new Date(selectedDate);
        newDate.setDate(newDate.getDate() + 1);
        setSelectedDate(newDate);
    };

    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.value) return;
        setSelectedDate(new Date(e.target.value));
    };

    return (
        <div className="attendance-container">
            <div style={{ padding: "12px 12px 0 12px" }}>
                <h2 className="title-text notification-heading" style={{ margin: 0 }}>
                    Hostel
                </h2>
            </div>
            {/* Hostel Details */}
            <div className="event-container" style={{
                marginTop: "0px"
            }}>
                <div className="page-title">{hostel.title}</div>

                <div className="student-divider"></div>

                <div className="student-details-margin">
                    <strong>Ward :</strong> {hostel.ward}
                </div>

                <div className="student-details-margin">
                    <strong>Room :</strong> {hostel.room}
                </div>

                <div className="student-details-margin">
                    <strong>Incharge :</strong> {hostel.incharge}
                </div>
            </div>

            {/* Services */}
            <div className="event-container">
                <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ cursor: "pointer" }}
                >
                    <span
                        style={{
                            fontWeight: 600,
                            color: "var(--colorPrimaryDark)",
                            fontSize: "16px",
                        }}
                    >
                        Services
                    </span>

                    <i className="fa fa-chevron-right"></i>
                </div>
            </div>

            {/* Schedule */}
            <div className="event-container">
                <div className="page-title">Schedule</div>

                <div className="student-divider"></div>

                {scheduleList.map((item, index) => (
                    <div
                        key={index}
                        className="student-details-margin"
                        style={{ padding: "4px 0" }}
                    >
                        {item}
                    </div>
                ))}
            </div>

            {/* Date Navigation */}
            <div className="attendance-summary-card">
                <div className="date-picker-container">
                    <button className="date-nav-btn" onClick={previousDay}>
                        <i className="fa fa-chevron-left"></i> Prev
                    </button>

                    <input
                        type="date"
                        className="date-input"
                        value={selectedDate.toISOString().split("T")[0]}
                        onChange={handleDateChange}
                    />

                    <button className="date-nav-btn" onClick={nextDay}>
                        Next <i className="fa fa-chevron-right"></i>
                    </button>
                </div>
            </div>

            {/* Food Menu */}
            <div className="event-container">
                <div
                    className="text-center"
                    style={{
                        fontWeight: 700,
                        color: "var(--colorAccentDark)",
                        fontSize: "18px",
                    }}
                >
                    Food Menu <i className="fa fa-cutlery ms-2"></i>
                </div>

                <div className="student-divider"></div>

                {foodMenu.map((menu, index) => (
                    <div
                        key={index}
                        className="d-flex justify-content-between align-items-center"
                        style={{
                            padding: "10px 0",
                            borderBottom:
                                index !== foodMenu.length - 1
                                    ? "1px dashed #eee"
                                    : "none",
                        }}
                    >
                        <strong style={{ color: "var(--colorPrimaryDark)" }}>
                            {menu.meal}
                        </strong>

                        <span>{menu.item}</span>
                    </div>
                ))}
            </div>

            {/* Wallet & Requests */}
            <div className="fee-buttons-row">
                <button className="fee-btn transactions-btn">
                    Wallet
                </button>

                <button className="fee-btn paynow-btn">
                    Requests
                </button>
            </div>
        </div>
    );
};

export default HostelContent;